import {WorkspaceSourceSummary} from '../ui/WorkspaceSourceSummary';
import type {SummaryMetricItem} from '../ui/SummaryStrip';
import type {PipelineSummary} from '../enquiries';
const count=(v:unknown):v is number=>typeof v==='number'&&Number.isSafeInteger(v)&&v>=0;
const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});
function subtotal(value:unknown,missing:unknown,format:(n:number)=>string){
 if(typeof value!=='number'||!Number.isFinite(value)||value<0||!count(missing))return undefined;
 if(missing===0)return format(value);
 return value>0?`At least ${format(value)}`:undefined;
}
const metric=(label:string,value:string|number|undefined):SummaryMetricItem=>value===undefined?
 {label,state:'unavailable',unavailableLabel:'Unknown'}:{label,value};
export function EnquiryPipelineSummary({summary,loaded}:{summary:PipelineSummary;loaded:string}){
 const units=subtotal(summary.active_known_units,summary.active_units_incomplete_count,n=>n.toLocaleString('en-GB'));
 const rawValue=summary.estimated_pipeline_annual_value??summary.pipeline_annual_value;
 const numericValue=typeof rawValue==='number'?rawValue:typeof rawValue==='string'&&rawValue.trim()?Number(rawValue):undefined;
 const value=subtotal(numericValue,summary.active_value_missing_count,n=>money.format(n));
 const coverage=[
  'Active means New, Qualified, Proposal, Negotiation or Decision pending. Won, Lost and Deferred are excluded.',
  'Annual value uses the current management-agreement fee where available, otherwise the enquiry estimate; it is not earned revenue.',
  'Units are the residential and commercial counts declared on the leads, not verified building totals.',
  count(summary.active_units_incomplete_count)?`${summary.active_units_incomplete_count} active leads have one or both unit counts missing.`:'Unit coverage is unavailable.',
  count(summary.active_value_missing_count)?`${summary.active_value_missing_count} active leads have no recorded annual fee or estimate.`:'Value coverage is unavailable.',
  'A partial subtotal is shown as At least; a wholly unknown amount is shown as Unknown.'
 ].join(' ');
 return <div><p className="workspace-source-note">Organisation-wide active pipeline. Register filters do not change these totals.</p>
  <WorkspaceSourceSummary label="Active pipeline overview" loaded={loaded} basis={coverage} items={[
   metric('Active leads',count(summary.active_count)?summary.active_count:undefined),metric('Annual pipeline value',value),metric('Declared units',units)
  ]}/>
 </div>;
}
